import { render, staticRenderFns } from "./ShapeEditorControl.vue?vue&type=template&id=b95b2fce&scoped=true"
import script from "./ShapeEditorControl.vue?vue&type=script&lang=js"
export * from "./ShapeEditorControl.vue?vue&type=script&lang=js"
import style0 from "./ShapeEditorControl.vue?vue&type=style&index=0&id=b95b2fce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95b2fce",
  null
  
)

export default component.exports